import { useState } from 'react';
import clsx from 'clsx';
import { TBuildingStreetWrapper } from 'api/hooks/use-building-search';
import { CheckBox } from 'components/check-box2';
import RadioButton from 'components/radio-button';
import styles from './styles.module.scss';

interface IStreetWrapper {
  i: TBuildingStreetWrapper;
  idx: number;
  selectedIds: number[];
  setSelectedIds: (ids: number[]) => void;
}

export const StreetWrapper: React.FC<IStreetWrapper> = (props: IStreetWrapper) => {
  const { i, idx, selectedIds, setSelectedIds } = props;

  const checked = !!i.buildings.find((b) => selectedIds.includes(b.id));

  const [showHouse, setShowHouse] = useState(checked);
  const updateCounter = (upd: number[]) => {
    let counter = 0;

    i.buildings.forEach((b) => {
      if (upd.includes(b.id)) {
        counter += b.countFacilites;
      }
    });
  };

  const updateState = (ids: number[], e: boolean) => {
    let updated = [];
    if (!e) {
      updated = selectedIds.filter((id) => !ids.includes(id));
      setSelectedIds(updated);
    } else {
      updated = [...selectedIds, ...ids.filter((id) => !selectedIds.includes(id))];
      setSelectedIds(updated);
    }

    updateCounter(updated);
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <CheckBox
          checked={showHouse}
          onChange={() => {
            setShowHouse(!showHouse);
          }}
          style={{ padding: 0 }}
        />
        <RadioButton
          label={i.streetName}
          key={i.streetName}
          className={clsx(styles.checkbox, idx === i.buildings.length - 1 && styles.checkboxLast)}
          labelPosition='left'
          checked={checked}
          onChange={(e) =>
            updateState(
              i.buildings.map((b) => b.id),
              e,
            )
          }
        />
      </div>

      {showHouse &&
        i.buildings.map((building) => (
          <RadioButton
            label={building.house}
            className={styles.checkbox}
            key={building.id}
            labelPosition='left'
            checked={selectedIds.includes(building.id)}
            onChange={(e) => updateState([building.id], e)}
          />
        ))}
    </div>
  );
};
